import React, { useState, useEffect } from "react"
import { Link, graphql } from "gatsby"
import { PrismicLink } from "@prismicio/react"
import {
  Navbar as ReactBootstrapNavbar,
  Nav,
  Image,
  Container,
} from "react-bootstrap"
import CustomDropdown from "./CustomDropdown"
import { LanguageSwitcher } from "./LanguageSwitcher"

const SCROLL_THRESHOLD = 24

export const Navbar = ({ navbar, activeDocMeta }) => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const update = () => {
      const next = window.scrollY > SCROLL_THRESHOLD
      setScrolled(prev => (prev === next ? prev : next))
    }
    update()
    window.addEventListener("scroll", update, { passive: true })
    return () => window.removeEventListener("scroll", update)
  }, [])

  const subCategories = navbar.body.filter(
    slice => slice.slice_type === "subcategories"
  )

  return (
    <header className="main-navbar position-relative">
      <ReactBootstrapNavbar expand="lg" className={`navbar${scrolled ? " scrolled" : ""}`} fixed="top">
        <Container>
          <ReactBootstrapNavbar.Brand as="div" className="p-0">
            <Link
              className="d-inline-flex align-items-center text-decoration-none"
              to="/"
              aria-label="Grub24 home"
            >
              <Image
                alt=""
                src="/logo.png"
                className="d-inline-block align-middle img-st-1"
              />
              <span className="logo ms-2">GrubPOS</span>
            </Link>
          </ReactBootstrapNavbar.Brand>
          <ReactBootstrapNavbar.Toggle aria-controls="navbarScroll" />
          <ReactBootstrapNavbar.Collapse id="navbarScroll">
            <Nav
              className="w-100 d-flex flex-column flex-lg-row justify-content-between"
              aria-label="Main navigation"
              navbarScroll
            >
              {/* This is the first group of links */}
              <div className="nav-group-1 order-1 order-lg-2 d-flex flex-row justify-content-center align-items-center">
                <div className="mt-4 mb-3 mx-lg-2 my-lg-3">
                  <Link className="btn-signup" to="/contact">
                    Get a demo
                  </Link>
                </div>
                {/* Language Switcher */}
                <div className="mt-4 mb-3 mx-lg-2 my-lg-3">
                  <LanguageSwitcher activeDocMeta={activeDocMeta} />
                </div>
              </div>

              {/* This is the second group of links */}
              <div className="nav-group-2 order-2 order-lg-1 d-lg-flex flex-row justify-content-center align-items-center ms-lg-4">
                <hr className="mt-2 mb-3 d-lg-none" />

                {navbar &&
                  navbar.main_categories.map((category, index) => {
                    const sections = subCategories.filter(
                      subCategory =>
                        category.category_number ===
                        subCategory.primary.category_number
                    )

                    return (
                      <React.Fragment key={`category-item-${index}`}>
                        {index !== 0 && <hr className="divider-st-2" />}

                        {sections.length !== 0 ? (
                          <CustomDropdown
                            toggleText={category.title}
                            sections={sections}
                          />
                        ) : (
                          <PrismicLink
                            field={category.link}
                            className={`nav-link-st-1 ${category.right_align ? "ms-auto" : ""}`}
                          >
                            {category.title}
                          </PrismicLink>
                        )}
                      </React.Fragment>
                    )
                  })}
              </div>
            </Nav>
          </ReactBootstrapNavbar.Collapse>
        </Container>
      </ReactBootstrapNavbar>
    </header>
  )
}

export const query = graphql`
  fragment NavbarFragment on PrismicNavbar {
    _previewable
    type
    lang
    data {
      main_categories {
        category_number
        title
        right_align  # Ensure this field is fetched
        link {
          url
          target
          link_type
        }
      }
      body {
        ... on PrismicNavbarDataBodySubcategories {
          id
          slice_type
          items {
            icon {
              alt
              url
            }
            label
            link {
              url
              target
              link_type
            }
          }
          primary {
            category_number
            subtitle
            title
          }
        }
      }
    }
  }
`
